import {
  RichTextEditorContent,
  type RichTextEditorProps,
} from "@/components/RichTextEditorContent";

/**
 * WYSIWYG markdown editor. Renders formatted content as the user types while
 * reading and writing plain markdown, so every existing markdown consumer keeps
 * working unchanged.
 *
 * @param props - The editor props
 * @returns The rich text editor
 */
export function RichTextEditor(props: RichTextEditorProps) {
  return <RichTextEditorContent {...props} />;
}
